import type { ReactNode } from 'react';
import './ChoixEntoures.css';

/** Un choix d'une ligne des Réglages : sa clé, son mot, et ce qu'il dit au survol. */
export interface ChoixAEntourer<T extends string> {
  cle: T;
  mot: ReactNode;
  titre?: string;
  tuto?: string;
}

/**
 * **Les choix d'une ligne des Réglages, entourés au crayon** (chantier reglages-de-la-fiche,
 * deuxième passe de 02 ; maquette `boutons-des-reglages.html`, façon 4, `.p4`) : tous visibles
 * d'un coup, écrits à la main, le choisi entouré d'un trait de crayon bleu. Aucun menu ne s'ouvre.
 * Le dessin seulement : ce que fait un clic, c'est la ligne qui le dit (`onChoisir`).
 */
export function ChoixEntoures<T extends string>({
  choix,
  choisi,
  onChoisir,
  nom,
}: {
  choix: readonly ChoixAEntourer<T>[];
  /** Le choix entouré ; `null` : aucun ; une liste quand la ligne tient deux questions (« Où »). */
  choisi: T | null | readonly (T | null)[];
  onChoisir: (cle: T) => void;
  /** Le nom du groupe, lu par un lecteur d'écran. */
  nom: string;
}) {
  const estChoisi = (cle: T) => (Array.isArray(choisi) ? choisi.includes(cle) : cle === choisi);
  return (
    <div className="choix-entoures" role="group" aria-label={nom}>
      {choix.map((c) => (
        <button
          key={c.cle}
          type="button"
          className="choix-entoure"
          aria-pressed={estChoisi(c.cle)}
          title={c.titre}
          data-tuto={c.tuto}
          data-valeur={c.cle}
          onClick={() => onChoisir(c.cle)}
        >
          {c.mot}
        </button>
      ))}
    </div>
  );
}
